<template>
  <Card
    class="mb-3 border border-slate-100 text-left cursor-pointer overflow-hidden"
  >
    <div
      class="flex justify-between hover:bg-slate-100 p-4"
      @click="toggleShowDocuments"
    >
      <h2 class="font-bold" v-html="highlightText(name)"></h2>
      <box-icon class="h-5 w-5" name="chevron-down" />
    </div>
    <div class="px-3" v-if="showDocuments || searchedDocument?.length">
      <input
        v-if="!searchedDocument.length"
        type="search"
        name="company-document-search"
        placeholder="Search Documents"
        class="border rounded-md p-3 outline-blue-400 my-6 w-full"
        v-model="documentSearch"
      />
      <div v-if="!documentSearch.length">
        <FolderItem
          v-for="(folder, key) in groupedFolders"
          :key="key"
          :folderName="key"
          :folder="folder"
        />
      </div>
      <div v-else>
        <div v-if="isObjectEmpty(searchedFolders)" class="p-5 mb-3 text-center">
          No results for "{{ documentSearch }}"
        </div>
        <FolderItem
          v-for="(folder, key) in searchedFolders"
          :key="key"
          :folderName="key"
          :folder="folder"
          :highlightedText="documentSearch"
        />
      </div>
    </div>
  </Card>
</template>

<script>
import { onMounted, reactive, ref, computed, watch } from "vue";
import Card from "./Card.vue";
import FolderItem from "./FolderItem.vue";

export default {
  name: "CompanyItem",
  components: {
    Card,
    FolderItem,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    highlightedText: {
      type: String,
    },
    searchedDocument: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const groupedFolders = reactive({});
    const showDocuments = ref(false);
    const documentSearch = ref("");
    const searchedFolders = computed(() => {
      let searchReults = {};

      for (const folder in groupedFolders) {
        const specialChars = /[^A-Z0-9]/gi;
        const documentConditions = documentSearch.value
          .toLowerCase()
          .split(specialChars);

        if (
          documentConditions.every((keyword) =>
            folder.toLowerCase().replace(specialChars, "").includes(keyword)
          )
        ) {
          searchReults[folder] = groupedFolders[folder];
        }
      }

      return searchReults;
    });

    const toggleShowDocuments = () => {
      showDocuments.value = !showDocuments.value;
    };

    const highlightText = (text) => {
      if (!props.highlightedText || !props.highlightedText.length) {
        return text;
      }
      return text.replace(new RegExp(props.highlightedText, "gi"), (match) => {
        return '<span class="highlightText">' + match + "</span>";
      });
    };

    const isObjectEmpty = (object) => {
      if (Object.keys(object).length === 0) {
        return true;
      }

      return false;
    };

    watch(
      () => props.searchedDocument,
      () => {
        documentSearch.value = props.searchedDocument;
      }
    );

    onMounted(() => {
      props.data.Folders.forEach((folder) => {
        if (!groupedFolders[folder.Name]) {
          groupedFolders[folder.Name] = [];
        }

        groupedFolders[folder.Name].push(folder);
      });
    });

    return {
      groupedFolders,
      showDocuments,
      documentSearch,
      searchedFolders,
      toggleShowDocuments,
      highlightText,
      isObjectEmpty,
    };
  },
};
</script>

<style>
.highlightText {
  background: yellow !important;
}
</style>
